import React from 'react';
import StarIcon from 'mdi-react/StarIcon';
import { withTranslation } from 'next-i18next';
import { WithTranslation as WithTranslationType } from 'next-i18next';

export interface RatingModalProps {
  onSubmit(value: number): void;
  onCancel(): void;
}

interface RatingModalState {
  value: number;
}

type Props = RatingModalProps & WithTranslationType;

export class _RatingModal extends React.Component<Props, RatingModalState> {
  constructor(props: Props) {
    super(props);
    this.state = {
      value: 5,
    };
  }

  public render() {
    const { onSubmit, onCancel } = this.props;
    const { value } = this.state;

    return (
      <>
        <div className="modal" onMouseLeave={onCancel}>
          <span>{this.props.t('RateRecipe')}</span>
          <div className="stars">{this.getStars()}</div>
          <div className="buttons">
            <button onClick={onCancel}>{this.props.t('Cancel')}</button>
            <button onClick={() => onSubmit(value)}>{this.props.t('Save')}</button>
          </div>
        </div>
        <style jsx>{`
          .modal :global(.star) {
            cursor: pointer;
          }

          @media (pointer: coarse) {
            .modal {
              text-align: center;
              background-color: #fff;
              box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.2);
              border-radius: 4px;
              padding: 20px 25px 22px;
            }

            .modal span {
              font-family: var(--font-family-primary);
              font-size: 15px;
              color: #343434;
            }

            .stars {
              display: flex;
              margin-top: 14px;
            }

            .modal :global(.star) {
              width: 42px;
              height: 42px;
            }

            .modal :global(.star:not(:first-child)) {
              margin-left: 10px;
            }

            .buttons {
              margin-top: 22px;
              display: flex;
            }

            .buttons button {
              width: 100%;
              height: 32px;
              border-radius: 4px;
              background-color: #fff;
              border: solid 1px #131415;
              font-family: var(--font-family-primary);
              font-size: 15px;
              color: #343434;
              cursor: pointer;
            }

            .buttons button:not(:first-child) {
              margin-left: 15px;
            }
          }

          @media (pointer: fine) {
            .overlay,
            .modal span,
            .buttons {
              display: none;
            }

            .stars {
              display: flex;
              background-color: #fff;
              border-radius: 4px;
              box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.2);
              padding: 5px 20px;
            }

            .modal :global(.star) {
              width: 30px;
            }
          }
        `}</style>
      </>
    );
  }

  private readonly onStarClick = (value: number) => {
    return (event: React.MouseEvent<HTMLDivElement, PointerEvent>) => {
      if ((event as any).pointerType === 'mouse') {
        this.props.onSubmit(value);
      } else {
        this.setState({ value });
      }
    };
  };

  private readonly getStars = () => {
    const result: JSX.Element[] = [];

    for (let i = 1; i <= 5; i++) {
      result.push(
        <div
          key={i}
          className="star"
          onPointerUp={this.onStarClick(i)}
          onMouseOver={() => this.setState({ value: i })}
        >
          <StarIcon color={this.state.value >= i ? '#057aff' : '#d8d8d8'} size="100%" />
        </div>,
      );
    }

    return result;
  };
}

export const RatingModal = withTranslation()(_RatingModal);
